import { format } from "date-fns";

export default class Formulas {
    values = {};
    inicalizar_valores = (val) => {
        this.values = { ...val };
    }

    setValues = (v) => {
        this.values = { ...v };
    }

    getValues = () => { return { ...this.values }; }

    plantas = (value = null) => {
        if (value !== null) this.values.plantas = parseFloat(value);

        this.values.cantidadTallos = parseFloat((this.values.plantas * this.values.recuperacion).toFixed(2));
        this.values.semillas = parseFloat((this.values.por_germinacion > 0 ? this.values.plantas / this.values.por_germinacion : 0).toFixed(2));
        this.values.reqm2 = parseFloat((this.values.densidad > 0 ? this.values.plantas / this.values.densidad : 0).toFixed(2));
    }

    plantasCreacion = () => {
        this.values.talloscosecha = parseFloat((this.values.plantas * this.values.recuperacion).toFixed(2));
        this.values["sem.necesaria"] = parseFloat((this.values.germinacion > 0 ? this.values.plantas / this.values.germinacion : 0).toFixed(2));
        this.values.metrosnecesarios = parseFloat((this.values.densidad > 0 ? this.values.plantas / this.values.densidad : 0).toFixed(2));
    }

    tallos = (value = null) => {
        if (value !== null) this.values.cantidadTallos = parseFloat(value);
        this.values.recuperacion = parseFloat((this.values.plantas > 0 ? this.values.cantidadTallos / this.values.plantas : 0).toFixed(4));
    }

    tallosCreacion = () => {
        this.values.recuperacion = parseFloat((this.values.plantas > 0 ? this.values.talloscosecha / this.values.plantas : 0).toFixed(4));
    }

    semillas = (value = null) => {
        if (value !== null) this.values.semillas = parseFloat(value);
        this.values.por_germinacion = parseFloat((this.values.semillas > 0 ? this.values.plantas / this.values.semillas : 0).toFixed(4));
    }

    semillasCreacion = () => {
        this.values.germinacion = parseFloat((this.values["sem.necesaria"] > 0 ? this.values.plantas / this.values["sem.necesaria"] : 0).toFixed(4));
    }

    metros = (value = null) => {
        if (value !== null) this.values.reqm2 = parseFloat(value);
        this.values.densidad = parseFloat((this.values.reqm2 > 0 ? this.values.plantas / this.values.reqm2 : 0).toFixed(2));
    }

    metrosCreacion = () => {
        this.values.densidad = parseFloat((this.values.metrosnecesarios > 0 ? this.values.plantas / this.values.metrosnecesarios : 0).toFixed(2));
    }

    recuperacion = (value = null) => {
        if (value !== null) this.values.recuperacion = parseFloat(value);
        this.values.tallos = parseFloat((this.values.plantas * this.values.recuperacion).toFixed(2));
    }

    recuperacionCreacion = () => {
        this.values.talloscosecha = parseFloat((this.values.plantas * this.values.recuperacion).toFixed(2));
    }

    germinacion = (value = null) => {
        if (value !== null) this.values.por_germinacion = parseFloat(value);
        this.values.semillas = parseFloat((this.values.por_germinacion > 0 ? this.values.plantas / this.values.por_germinacion : 0).toFixed(2));
    }

    germinacionCreacion = () => {
        this.values["sem.necesaria"] = parseFloat((this.values.germinacion > 0 ? this.values.plantas / this.values.germinacion : 0).toFixed(2));
    }

    densidad = (value = null) => {
        if (value !== null) this.values.densidad = parseFloat(value);
        this.values.reqm2 = parseFloat((this.values.densidad > 0 ? this.values.plantas / this.values.densidad : 0).toFixed(2));
    }

    densidadCreacion = () => {
        this.values.metrosnecesarios = parseFloat((this.values.densidad > 0 ? this.values.plantas / this.values.densidad : 0).toFixed(2));
    }

    charolas = (value = null) => {
        if (value !== null) this.values.charolas = parseFloat(value);
        this.values.plantas = parseFloat((this.values.por_germinacion * 288 * this.values.charolas).toFixed(2));
        this.plantas();
    }

    charolasCreacion = () => {
        this.values.plantas = parseFloat((this.values.germinacion * 288 * this.values["#charolas"]).toFixed(2));
        this.plantasCreacion();
    }

    number_format(num) {
        let form = parseFloat(num);
        if (isNaN(form)) return 0;
        return form;
    }

    modificarPropagacionCampo = (propagacion, campo) => {
        propagacion = this.number_format(propagacion);
        campo = this.number_format(campo);
        this.values.propagacion = propagacion;
        this.values.campo = campo;
        let cosecha = this.agregarSemanas(this.values.semana_siembra, (this.values.campo + this.values.propagacion));
        if (cosecha) {
            this.values.semana_campo = cosecha.semana;
            this.values.semanaCosecha = cosecha.semana;
        }
        let trans = this.agregarSemanas(this.values.semana_siembra, +this.values.propagacion);
        if (trans) {
            this.values.transplante = trans.semana;
            this.values.fecha_trans = trans.fecha;
        }
    }

    modificarPropagacionCampoCreacion = () => {
        let cosecha = this.agregarSemanas(this.values.semanasiembra, (+this.values.ciclocampo + +this.values.ciclopropagacion));
        if (cosecha) {
            this.values.semcampo = cosecha.semana;
        }
        let trans = this.agregarSemanas(this.values.semanasiembra, +this.values.ciclopropagacion);
        if (trans) {
            this.values.semanatrasplante = trans.semana;
        }
    }

    modificarSemanaSiembra = (semana) => {
        this.values.semanainicio = semana;
        this.values.semana_siembra = semana;
        let resp = this.agregarSemanas(this.values.semanainicio, 0);
        if (!resp) return;

        this.values.fecha_inicio = resp.fecha;
        resp = this.agregarSemanas(this.values.semana_siembra, +this.values.propagacion);
        if (!resp) return;

        this.values.fecha_trans = resp.fecha;
        this.values.transplante = resp.semana;

        resp = this.agregarSemanas(this.values.semana_siembra, +this.values.propagacion + +this.values.campo);
        if (!resp) return;
        this.values.semana_campo = resp.semana;
        this.values.semanaCosecha = resp.semana;
        return;
    }

    modificarSemanaSiembraCreacion = () => {
        let resp = this.agregarSemanas(this.values.semanasiembra, +this.values.ciclopropagacion);
        if (!resp) return;

        this.values.semanatrasplante = resp.semana;

        resp = this.agregarSemanas(this.values.semanasiembra, +this.values.ciclopropagacion + +this.values.ciclocampo);
        if (!resp) return;
        this.values.semcampo = resp.semana;
        return;
    }

    modificarSemanaTransplante = (trasplante) => {
        if (isNaN(parseInt(trasplante))) return;
        this.values.transplante = trasplante;
        let resp = this.agregarSemanas(this.values.transplante, 0);
        if (!resp) return;
        this.values.fecha_trans = resp.fecha;

        resp = this.agregarSemanas(this.values.transplante, +this.values.propagacion * -1);
        if (!resp) return;
        this.values.semanainicio = resp.semana;
        this.values.semana_siembra = resp.semana;
        this.values.fecha_inicio = resp.fecha;

        resp = this.agregarSemanas(this.values.transplante, +this.values.campo);
        if (!resp) return;
        this.values.semana_campo = resp.semana;
        this.values.semanaCosecha = resp.semana;

        return;
    }

    modificarSemanaTransplanteCreacion = () => {
        let resp = this.agregarSemanas(this.values.semanatrasplante, +this.values.ciclopropagacion * -1);
        if (!resp) return;
        this.values.semanasiembra = resp.semana;

        resp = this.agregarSemanas(this.values.semanatrasplante, +this.values.ciclocampo);
        if (!resp) return;
        this.values.semcampo = resp.semana;

        return;
    }

    modificarSemanacosecha = (semana) => {
        this.values.semana_campo = semana;
        this.values.semanaCosecha = semana;

        let resp = this.agregarSemanas(this.values.semanaCosecha, +this.values.campo * -1);
        if (!resp) return;
        this.values.transplante = resp.semana;
        this.values.fecha_trans = resp.fecha;

        resp = this.agregarSemanas(this.values.semanaCosecha, (+this.values.campo + +this.values.propagacion) * -1);
        if (!resp) return;
        this.values.semanainicio = resp.semana;
        this.values.semana_siembra = resp.semana;
        this.values.fecha_inicio = resp.fecha;

        return;
    }

    modificarSemanacosechaCreacion = () => {
        let resp = this.agregarSemanas(this.values.semcampo, +this.values.ciclocampo * -1);
        if (!resp) return;
        this.values.semanatrasplante = resp.semana;

        resp = this.agregarSemanas(this.values.semcampo, (+this.values.ciclocampo + +this.values.ciclopropagacion) * -1);
        if (!resp) return;
        this.values.semanasiembra = resp.semana;
        return;
    }

    agregarSemanas = (semana, add) => {
        semana = `${semana}`;
        if (semana.length != 4) return false;
        add = parseInt(add);

        if (isNaN(add)) return null;

        let anio = parseInt(semana.substring(0, 2));
        if (isNaN(anio) || anio < 23) return false;

        let sm = parseInt(semana.substring(2, 4));
        if (isNaN(sm) || sm < 0 || sm > 52) return false;
        //ajustamos el numero de la semana previendo que esta pueda servazar el año
        if ((sm + add) > 52) {
            anio++;
            sm = (sm + add) - 52;
        } else if ((sm + add) < 1) {
            anio--;
            sm = 52 + add;
        } else sm = (sm + add);


        let fecha = new Date(anio + 2000, 0, 1);

        //Si el 01-01 es lunes son las semanas completas, si es un dia diferente el primer lunes del año comeienza la semana 02
        const semanasASumar = fecha.getDay() !== 1 ? sm : sm - 1;

        while (fecha.getDay() !== 1) fecha.setDate(fecha.getDate() + 1); // Añadir un día

        fecha.setDate(fecha.getDate() + (7 * semanasASumar));
        let fechaString = this.dateYYYYMMDD(fecha);

        return { semana: `${anio}${sm < 10 ? `0${sm}` : sm}`, fecha: fechaString }
    }

    dateYYYYMMDD = (fecha) => {
        // Obteniendo componentes de la fecha
        let year = fecha.getFullYear();
        let month = fecha.getMonth() + 1; // ¡Recuerda que los meses comienzan desde 0!
        let day = fecha.getDate();

        // Agregando ceros iniciales si es necesario
        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;

        // Construyendo la cadena en el formato "YYYY-MM-DD"
        let formatoYYYYMMDD = `${year}-${month}-${day}`;

        return formatoYYYYMMDD;
    }
}